import styled from 'styled-components';

export const InputContainer = styled.div`
  position: relative;
  display: inline-block;
  width: 100%;
`;

export const PrimaryInput = styled.input<{ variant?: string }>`
  background-color: #f2f2f2;
  border: 1px solid #dadada;
  color: #696969;
  padding: 20px 15px;
  width: 100%;
  height: 48px;
  border-radius: 16px;
  font-size: 12px;

  &::-webkit-calendar-picker-indicator {
    display: none;
    -webkit-appearance: none;
  }

  ${({ variant }) =>
    variant === 'dynamic-filter' &&
    `
    background-color: transparent;
    border: none;
    border-radius: 0;
    padding: 8px;
    height: auto;
    margin: 0;
    outline: none;
  `}

  ${({ variant }) =>
    variant === 'date-input' &&
    `
    border-radius: 28px;
    background-color: transparent;
    width: 100%;
    min-width: 130px;
  `}

  &.small {
    height: 40px;
    margin: 4px 0px 0px;
  }

  &.bg-white {
    background-color: white;
  }

  &:disabled {
    background-color: #f2f2f2;
    color: #696969;
    cursor: not-allowed;
  }

  &.check {
    background-color: #e8f0fe;
    color: #2c2d2f;
  }

  &.rounded {
    border-radius: 25px !important;
  }

  &.block {
    width: 100%;
  }
`;

export const RightContent = styled.a`
  position: absolute;
  right: 18px;
  top: 14px;
  cursor: pointer;
`;

export const ClearButton = styled.a`
  cursor: pointer;
  color: rgb(30, 119, 208);
  font-size: 16px;
`;

export const ErrorText = styled.span`
  text-align: left;
  color: red;
  font-size: 12px;
  align-self: flex-start;
`;
